import React, { useState, useEffect, useRef } from "react";

import { Capabilities } from "./Capabilities";
import { Header } from "./Header";
import { Quote } from "./Quote";

const HeaderText = () => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <div 
      className="splash-header-text-container" 
      ref={containerRef}
    >
      <div className="splash-cards-wrapper">
        <div className={`splash-card ${isVisible ? 'visible' : ''} card-1`}>
          <h3 className="card-heading">Our Mission</h3>
          <p>
            TransAstra is making <span className="highlight">asteroid mining</span> a reality. 
            To do this, we are developing four core capabilities:{" "}
            <span className="capability-word detect">Detect</span>,{" "}
            <span className="capability-word capture">Capture</span>,{" "}
            <span className="capability-word move">Move</span>, and{" "}
            <span className="capability-word process">Process</span>.
          </p>
        </div>

        <div className={`splash-card ${isVisible ? 'visible' : ''} card-2`}>
          <h3 className="card-heading">Space Domain Awareness</h3>
          <p>
            Today we operate a global network of telescopes leveraging our unique{" "}
            <span className="capability-word detect">Detect</span>{" "}
            capability to find object throughout space.
          </p>
        </div>

        <div className={`splash-card ${isVisible ? 'visible' : ''} card-3`}>
          <h3 className="card-heading">Active On-Orbit</h3>
          <p>
            In October 2025, we deployed our{" "}
            <span className="capability-word capture">Capture</span>{" "}
            bag on the <span className="highlight-org">International Space Station</span> to enable 
            orbital debris cleanup and promote Responsible Space Operations for the Space Force.
          </p>
        </div>
      </div>
    </div>
  );
};

const SplashPage = () => {
  return (
    <div>
      <Header />
      <HeaderText />
      <Capabilities />
      <Quote />
    </div>
  );
};

export default SplashPage;
